<template>
  <div class="popular-apps-container">
    <div v-if="isPopularAppsLoading">
      <generic-loading-skeleton />
    </div>
    <div v-else>
      <div class="pb-2"><h2>Popular links</h2></div>
      <div class="alert alert-error" v-if="isLoadingError">{{ errorMsg }}</div>
      <div v-else>
        <div
          class="mr-2 popular-apps-card pb-16-px pl-1"
          v-for="app in popularApps"
          :key="app.id"
        >
          <a :href="app.url" :target="getLinkTarget(app)">
            <img
              class="popular-apps-image"
              :src="app.image"
              @click="navigateToApp(app)"
            />
            <span
              class="popular-app-title ml-1 align-middle"
              @click="navigateToApp(app)"
              >{{ app.title }}</span
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import * as CONSTANTS from "@/store/constants";
import GenericLoadingSkeleton from "./GenericLoadingSkeleton";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "PopularApps",
  mixins: [HomebaseMixpanelMixin],
  components: {
    GenericLoadingSkeleton,
  },
  data() {
    return {
      isLoadingError: false,
      popularApps: [],
      errorMsg: CONSTANTS.SERVER_ERROR_MESSAGE,
      isPopularAppsLoading: false,
      applicationAccessDashboardLink:
        CONSTANTS.APPLICATION_ACCESS_DASHBOARD_LINK,
    };
  },
  created() {
    this.getPopularApps();
  },
  methods: {
    async getPopularApps() {
      try {
        this.isPopularAppsLoading = true;
        let response = await api.getPopularApps();
        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.data.popularApps
        ) {
          this.popularApps = response.data.data.popularApps.sort((a, b) =>
            a.title > b.title ? 1 : -1
          );
        } else {
          this.isLoadingError = true;
        }
      } catch (error) {
        this.isLoadingError = true;
      } finally {
        this.isPopularAppsLoading = false;
      }
    },

    navigateToApp(app) {
      let subEvent = app.title + " - " + app.url;
      this.trackPopularLink(subEvent);
    },

    getLinkTarget(record) {
      return record.newTab ? "_blank" : "_self";
    }
  },
};
</script>

<style scoped>
.panel-title-sm {
  padding-bottom: 20px;
}
.popular-app-title {
  font-size: 16px;
}
.popular-apps-image {
  max-width: 20px;
  max-height: 20px;
  object-fit: cover;
  display: inline;
}

.popular-apps-card {
  cursor: pointer;
}
.popular-apps-card a {
  color: black !important;
  text-decoration: none !important;
}

</style>


// WEBPACK FOOTER //
// src/components/homebase/PopularApps.vue